<template>
  <div>
    <div class="ui form">
      <div class="fields">
        <div class="eight wide field" style="padding-top:25px;">
          <label>{{ $t("components.historicalAccessControl.Fecha_inicio") }}</label>
          <div class="ui calendar" id="fecha-inicio">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text">
            </div>
          </div>
        </div>
        <div class="eight wide field" style="padding-top:25px;">
          <label>{{ $t("components.historicalAccessControl.Fecha_fin") }}</label>
          <div class="ui calendar" id="fecha-fin">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text">
            </div>
          </div>
        </div>
      </div>
      <div class="fields">
        <div class="eight wide field">
          <label>{{ $t("components.historicalAccessControl.Usuario") }}</label>
          <div class="ui action input">
            <select class="ui dropdown fluid" v-model="currentUserSelected" @change="refresh">
              <option value="0">{{ $t('components.historicalAccessControl.Todos') }}</option>
              <option v-bind:value="user._id" v-bind:key="user._id" v-for="user in allUsers">
                {{ (user.usuarioSistema != null) ? (user.usuarioSistema.name + ' (' + user.usuarioSistema.login + ')') : user.description }}
              </option>
            </select>
          </div>
        </div>
        <div class="eight wide field">
          <label>{{ $t("components.historicalAccessControl.Dispositivo") }}</label>
          <div class="ui action input">
            <select class="ui dropdown fluid" v-model="currentTerminalSelected" @change="refresh">
              <option value="0">{{ $t('components.historicalAccessControl.Todos') }}</option>
              <option v-bind:value="controller._id" v-bind:key="controller._id" v-for="controller in allControllers">
                {{ controller.description }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <h3 class="ui dividing header" style="margin-top: 0px"></h3>
    <table v-if="events.length > 0" class="ui compact celled table selectable sortable">
      <thead class="full-width">
        <tr>
          <th class="four wide">{{ $t("components.historicalAccessControl.Fecha") }}</th>
          <th class="four wide">{{ $t("components.historicalAccessControl.Usuario") }}</th>
          <th class="five wide">{{ $t("components.historicalAccessControl.Dispositivo") }}</th>
          <th class="three wide">{{ $t("components.historicalAccessControl.Acceso") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="event in events" v-bind:key="event._id">
          <td>{{ (event.fechahora != null) ? moment(event.fechahora).locale($i18n.locale).format('YYYY/MM/DD HH:mm:ss') : '' }}</td>
          <td>{{ getNombreUsuario(event) }}</td>
          <td>{{ getNombreTerminal(event) }}</td>
          <td>{{ getTextoAcceso(event) }}</td>
        </tr>
      </tbody>
      <tfoot class="full-width">
        <tr>
          <th colspan="4">
            <button class="ui olive icon button" data-inverted="" :data-tooltip="$t('components.common.Exportar_excel')" data-position="bottom center" style="float:right" @click="exportTableToExcel">
              <i class="icon file excel large"></i>
            </button>
            <button class="ui olive icon button" data-inverted="" :data-tooltip="$t('components.common.Exportar_pdf')" data-position="bottom center" style="float:right" @click="exportTableToPdf">
              <i class="icon file pdf large"></i>
            </button>
            <button class="ui olive icon button" data-inverted="" :data-tooltip="$t('components.common.Buscar')" data-position="bottom center" style="float:right" @click="refresh">
              <i class="icon sync alternate large"></i>
            </button>
          </th>
        </tr>
      </tfoot>
    </table>
    <div v-if="events.length === 0">
      <div class="ui icon warning message">
        <i class="icon exclamation circle"></i>
        <div class="content">
          <div class="header">
            {{ $t('components.historicalAccessControl.No_hay_eventos') }}
          </div>
          <p>{{ $t('components.historicalAccessControl.Seleccione_rango_fechas') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from '../utils/axios-general';
import Vue from 'vue';
import JsPDF from 'jspdf';
import 'jspdf-autotable';
import XLSX from 'xlsx';

export default {
  name: 'TableHistoricalAccessControl',
  data: function () {
    return {
      table: null,
      currentFechaInicio: null,
      currentFechaFin: null,
      currentUserSelected: '0',
      currentTerminalSelected: '0',
      allUsers: [],
      allControllers: [],
      events: [],
      moment: Vue.moment,
      initialized: false
    };
  },
  methods: {
    calendarFormatDate: function (date, settings) {
      return this.moment(date).locale(this.$i18n.locale).format('LL');
    },
    onChangeFechaInicio: function (date, text, mode) {
      if (date == null) {
        return false;
      }

      this.currentFechaInicio = date;

      if (this.initialized) {
        Vue.nextTick(() => {
          this.refresh();
        });
      }

      return true;
    },
    onChangeFechaFin: function (date, text, mode) {
      if (date == null) {
        return false;
      }

      this.currentFechaFin = date;

      if (this.initialized) {
        Vue.nextTick(() => {
          this.refresh();
        });
      }

      return true;
    },
    exportTableToPdf: function () {
      const jsPDFInstance = new JsPDF();
      const body = [];

      for(const event of this.events) {
        body.push([
          (event.fechahora != null) ? this.moment(event.fechahora).locale(this.$i18n.locale).format('DD/MM/YYYY HH:mm:ss') : '',
          this.getNombreUsuario(event),
          this.getNombreTerminal(event),
          this.getTextoAcceso(event),
        ]);
      }

      jsPDFInstance.autoTable({
        head: [[
          this.$i18n.t("components.historicalAccessControl.Fecha"),
          this.$i18n.t("components.historicalAccessControl.Usuario"),
          this.$i18n.t("components.historicalAccessControl.Dispositivo"),
          this.$i18n.t("components.historicalAccessControl.Acceso"),
        ]],
        body,
      });

      jsPDFInstance.save(this.$i18n.t('components.historicalAccessControl.Fichero_export_nombre') + this.moment().locale(this.$i18n.locale).format('YYYYMMDDHHmmss') + '.pdf');
    },
    exportTableToExcel: function () {
      const rows = [[
        this.$i18n.t("components.historicalAccessControl.Fecha"),
        this.$i18n.t("components.historicalAccessControl.Usuario"),
        this.$i18n.t("components.historicalAccessControl.Dispositivo"),
        this.$i18n.t("components.historicalAccessControl.Acceso"),
      ]];

      for(const event of this.events) {
        rows.push([
          (event.fechahora != null) ? this.moment(event.fechahora).locale(this.$i18n.locale).format('DD/MM/YYYY HH:mm:ss') : '',
          this.getNombreUsuario(event),
          this.getNombreTerminal(event),
          this.getTextoAcceso(event),
        ]);
      }

      const worksheet = XLSX.utils.aoa_to_sheet(rows);
      worksheet['!cols'] = [
        {wch:20},
        {wch:40},
        {wch:40},
        {wch:15}
      ];
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, this.$i18n.t('components.historicalAccessControl.Excel_export_nombre_hoja'));
      XLSX.writeFile(workbook, this.$i18n.t('components.historicalAccessControl.Fichero_export_nombre') + this.moment().locale(this.$i18n.locale).format('YYYYMMDDHHmmss') + '.xlsx');
    },
    refresh: function () {
      axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
      axios.get('/event/info').then(response => {
        if (response) {
          this.allUsers = response.data.users;
          this.allControllers = response.data.controllers;

          // comprobamos si hay fecha de inicio
          if (this.currentFechaInicio == null) {
            this.$swal.fire({ type: 'error', title: this.$i18n.t('components.common.Error'), text: this.$i18n.t('components.historicalAccessControl.Introducir_fecha_inicio') });
            return;
          }

          // comprobamos si hay fecha de fin
          if (this.currentFechaFin == null) {
            this.$swal.fire({ type: 'error', title: this.$i18n.t('components.common.Error'), text: this.$i18n.t('components.historicalAccessControl.Introducir_fecha_fin') });
            return;
          }

          axios.defaults.headers.common['x-access-token'] = this.$store.state.user.token;
          axios.get('/event?' +
            'fechainicio=' + this.currentFechaInicio.toISOString() +
            '&fechafin=' + this.currentFechaFin.toISOString() +
            ((this.currentUserSelected !== '0') ? '&user=' + this.currentUserSelected : '') +
            ((this.currentTerminalSelected !== '0') ? '&terminal=' + this.currentTerminalSelected : '')
          ).then(response => {
            if (response) {
              if (this.table != null) {
                this.table.destroy();
              }

              this.events = response.data.events;

              setTimeout(() => {
                this.table = $('table').DataTable({
                  destroy: true,
                  order: [[ 0, 'desc' ]],
                  language: this.$i18n.t('components.datatable_language')
                });
              }, 500);
            }
          }).catch((e, a, b, c) => {
            this.$swal.fire({
              type: 'error',
              title: this.$i18n.t('components.common.Error'),
              text: e
            });
          });
        }
      }).catch((e, a, b, c) => {
        this.$swal.fire({
          type: 'error',
          title: this.$i18n.t('components.common.Error'),
          text: e
        });
      });
    },
    getNombreUsuario: function (event) {
      if ((event == null) || (event.data == null) || ((event.data.controlAccesosUsuario == null) && (event.data.userid == null))) {
        return this.$i18n.t('components.historicalAccessControl.Usuario_desconocido');
      }

      if ((event.data.controlAccesosUsuario == null) && (event.data.userid != null)) {
        return this.$i18n.t('components.historicalAccessControl.Usuario_desconocido') + ' (' + event.data.userid + ')';
      }

      const user = this.allUsers.find((u) => u._id === event.data.controlAccesosUsuario);

      if (user == null) {
        return '';
      }

      return (user.usuarioSistema != null) ? (user.usuarioSistema.name + ' (' + user.usuarioSistema.login + ')') : user.description;
    },
    getNombreTerminal: function (event) {
      if ((event == null) || (event.controller == null)) {
        return '';
      }

      const controller = this.allControllers.find((c) => c._id === event.controller);

      if (controller == null) {
        return '';
      }

      return controller.description;
    },
    getTextoAcceso: function (event) {
      if ((event == null) || (event.data == null) || (event.data.res == null)) {
        return '';
      }

      if ((event.data.res >= 0) && (event.data.res <= 4)) {
        return this.$i18n.t('components.historicalAccessControl.Acceso_' + event.data.res);
      } else {
        return '';
      }
    }
  },
  mounted: function () {
    this.currentFechaInicio = new Date();
    this.currentFechaInicio.setHours(0);
    this.currentFechaInicio.setMinutes(0);
    this.currentFechaInicio.setSeconds(0);
    this.currentFechaInicio.setMilliseconds(0);
    this.currentFechaFin = new Date();
    this.currentFechaFin.setHours(23);
    this.currentFechaFin.setMinutes(59);
    this.currentFechaFin.setSeconds(59);
    this.currentFechaFin.setMilliseconds(999);

    this.refresh();

    Vue.nextTick(() => {
      $('#fecha-inicio').calendar({
        type: 'date',
        text: this.$i18n.t('components.common.calendar'),
        ampm: false,
        firstDayOfWeek: 1,
        formatter: {
          date: this.calendarFormatDate
        },
        onChange: this.onChangeFechaInicio
      });

      $('#fecha-fin').calendar({
        type: 'date',
        text: this.$i18n.t('components.common.calendar'),
        ampm: false,
        firstDayOfWeek: 1,
        formatter: {
          date: this.calendarFormatDate
        },
        onChange: this.onChangeFechaFin
      });

      $('#fecha-inicio').calendar('set date', this.currentFechaInicio);
      $('#fecha-fin').calendar('set date', this.currentFechaFin);

      this.initialized = true;
    });

    setTimeout(() => {
      $('.ui.dropdown').dropdown();
    }, 500);
  }
};
</script>
